import * as S from './styles';
import { RootStateCarteira } from '../../../../store/carteiraReducer';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { formatToBRL } from 'base/src/utils/mathUtil';
import { Icon } from '@iconify/react';
import { useTheme } from 'base/src/utils/context/themeContext';

const connector = connectUtil(
  (state: RootStateCarteira) => ({
    homeInfo: state.CarteiraBaseReducer.CarteiraBase,
    homeInfoCampanha: state.CarteiraBaseReducer.CarteiraBaseCampanha,
  }),
  { }
);

export interface CarteiraHomeComponentProps extends PropsFromRedux<typeof connector> {}

function SecondaryCard (props: CarteiraHomeComponentProps) {
  const { theme } = useTheme();

  return (
    <S.Container>
      <S.TextContainer>
        <S.TitleContainer>
          <S.IconBadge color={theme.colors.positive}>
            <Icon icon="ph:currency-circle-dollar-bold" height={20} />
          </S.IconBadge>
          <S.Title>Valor Pago</S.Title>
          <S.Value>{props.homeInfo.EsconderSaldo ? "R$ *****,**" : formatToBRL(props.homeInfo.ValorPago || 0)}</S.Value>
        </S.TitleContainer>
      </S.TextContainer>
      <S.StyledLink to='/extrato'>
        <S.ActionButton>
          <Icon icon="ph:list-bold" height={16} />
          Extrato
        </S.ActionButton>
      </S.StyledLink>
    </S.Container>
  )
}

export default connector(SecondaryCard);
